import { DeviceModelState, DeviceModel } from '../types'
import Vue from 'vue'
import { GetterTree, MutationTree, ActionTree } from 'vuex'
import ApiResponse from 'models/apiResponse'


const state: DeviceModelState = {
    list: Array<DeviceModel>(),
    timestampMS: null
}

const getters: GetterTree<DeviceModelState, any> = {
    getDeviceModelList: state => () => {
        return state.list;
    }
}

const mutations: MutationTree<DeviceModelState> = {
    setDeviceModelList(state, data) {
        //reset list first.
        state.list = [];
        data.forEach((deviceModel: DeviceModel, index) => {
            Vue.set(state.list, index, deviceModel);
        });
    },
    setDeviceModelTimestamp(state) {
        // 1 Hour
        const expiration = 60 * 60 * 1000;
        state.timestampMS = new Date().getTime() + expiration;
    }
}

const actions: ActionTree<DeviceModelState, any> = {
    async fetchDeviceModels({ commit, state, dispatch }) {
            if (state.list.length == 0 || (state.timestampMS && new Date().getTime() > state.timestampMS)) {
                await dispatch('refreshDeviceModels');
            }
    },
    async refreshDeviceModels({ commit, state }) {
        const url = Vue.IdentityConfig.legacyApiUri + "/remote/models/list";
        const options: RequestInit = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: "no-cache"
        };
        await fetch(url, options)
            .then(response => response.json() as Promise<ApiResponse<Array<DeviceModel>>>)
            .then(data => {
                if (data.result) {
                    commit('setDeviceModelList', data.result);
                    commit('setDeviceModelTimestamp');
                }
                if (data.errors) {
                    data.errors.forEach(e => Vue.Logger.LogError(e.message));
                }
            });
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}